import React, { useEffect, useState, useRef, useCallback } from "react";
import {AiOutlineMail, AiOutlineUser} from 'react-icons/ai';
import {FiPhone, FiUserCheck} from 'react-icons/fi';
import {FaCertificate} from 'react-icons/fa';


import Connect from "../../../shared/redux/Connect.hoc";
// import Modal from 'react-bootstrap4-modal'
import { Modal } from "react-bootstrap";
import LoaderSpinner from '../../../shared/components/LoaderSpinner/LoaderSpinner'
import { createNotification } from '../../../utils/utils'

import cities from '../../../shared/data/cities.json';
import { fire } from '../../../db/config'

import './styles.scss'

// ? Redux
import { login } from "../../../shared/redux/action/admin.actions";

// ! Helpers
import { newClienteHP, validateEmailHP } from '../../../helpers/Cliente.helper'
import InputIcon from "../../../shared/atoms/input icon";
import SelectModal from "../../../shared/atoms/select";
import Button from "../../../shared/atoms/button";
import { useHistory } from "react-router-dom";

const Signin = ({ state, dispatch, visibleSignin, onCloseSignin, onSignin,onLogin }) => {
  const [showLoading, setShowLoading] = useState(false)
  const [alertState, updateAlertState] = useState(false)
  const [alertMessage, updateAlertMessage] = useState('')
  const [showAler, setShowAler] = useState(false)
  const [tokenPush, setTokenPush] = useState()
  const [emailDis, setEmailDis] = useState(true)
  const history = useHistory();
  const [fireToken, setFireToken] = useState('')

  const formRef = useRef(null)

  const tipoDocumento = [
    {name: 'Tipo de Documento'},
    {value: 'CC', name: 'Cedula Ciudadanía'},
    {value: 'CE', name: 'Cedula Extranjería'}
  ]


  useEffect(() => {
    console.log("--Signin.Component.useEffect--")
    const messaging = fire.messaging();
    messaging.requestPermission().then(() => {
      messaging.getToken().then(res => {
        console.log("--Signin.Component.apiSignin-- res: ", res)
        setFireToken(res)
      })
    }).catch(err => console.error('--Signin.Component.apiSignin-- error requestPermission', err));
  }, []);

  const clickOnLogin = () => {
    // onLogin()
    onCloseSignin()

  }

  const handleEmail = async (event) => {
    console.log("--Signin.Component.handleEmail--")
    console.log("--Signin.Component.handleEmail-- event.target.value: ", event.target.value)
    const email = event.target.value
    try {
      console.log("--Signin.Component.handleEmail-- email: ", email)
      const body = {
        email
      }
      const response = await validateEmailHP(body)
      if (response['code'] === 404) {
        console.error("Signin.Container.handleEmail response: ", response)
        setEmailDis(false)
        showAlert(response['message'])
      } else {
        setEmailDis(true)
        console.log("Signin.Container.handleEmail response: ", response)
        console.log("Signin.Container.handleEmail emailDis: ", emailDis)
      }
    } catch (error) {
      console.error("--Signin.Component.handleEmail-- error: ", error)
    }
  }



  const showAlert = (message) => {
    console.log("--Signin.Component.showAlert--")
    console.log("--Signin.Component.showAlert-- message: ", message)
    updateAlertState(true)
    updateAlertMessage(message)
    setTimeout(() => {
      updateAlertState(false)
    }, 2000)
  }

  const closeModal = () => {
    console.log("--Signin.Component.closeModal--")
    // formRef.current.reset()
    onCloseSignin()
  }

  const handleCreate = useCallback(
    async event => {
      console.log("--Signin.Component.handleCreate--")
      console.log("--Signin.Component.handleCreate-- emailDis: ", emailDis)
      console.log("--Signin.Component.handleCreate-- event.target.elements: ", event.target.elements)
      event.preventDefault()
      handleEmail(event)
      const { email, password, password2, name, lastname, tipodocumento, documento, celular, terminos,city } = event.target.elements
      console.log("--Signin.Component.handleCreate-- terminos.checked: ", terminos.checked)
      if (!terminos.checked) {
        showAlert('Debes aceptar los términos y condiciones')
        createNotification('Debes aceptar los términos y condiciones', 'warn')
        return
      }
      if (!emailDis) {
        showAlert('Este email ya está en uso por otro usuario')
        createNotification('Éste email ya está en uso', 'warn')
        return
      }
      if (password.value === '' || password.value.length < 6) {
        createNotification('La contraseña debe tener mínimo 6 caracteres', 'warn')
        showAlert('La contraseña debe tener mínimo 6 caracteres')
        return
      }
      if (password.value === password2.value) {
        console.log("--Signin.Component.handleCreate-- contraseñas iguales")
      } else {
        console.log("--Signin.Component.handleCreate-- contraseñas diferentes")
        createNotification('Las contraseñas no son iguales', 'warn')
        alert('Las contraseñas deben de coincidir')
        return
      }
      setShowLoading(true)

      let formData = {
        email: email.value,
        name: name.value,
        lastname: lastname.value,
        password: password.value,
        type_identification: tipodocumento.value,
        identification: documento.value,
        phone: celular.value,
        tokenfire: fireToken,
        city: city.value,
        platform: 'web',
        usertype: 2,
        rol: 'isUser',
        uuid: 'fireToken'
      }
      console.log('--Signin.Comoponent.handleCreate-- formData: ', formData)
      try {
        await apiSignin(formData, fireToken)
        setShowLoading(false)
        onSignin()
      } catch (error) {
        console.error('--Signin.Comoponent.handleCreate-- error: ', error)
        setShowLoading(false)
      }
    }, [fireToken]
  )

  const apiSignin = async (body, sbToken) => {
    console.log("--Signin.Component.apiSignin--")
    console.log("--Signin.Component.apiSignin-- body: ", body)
    try {
      const response = await newClienteHP(body)
      console.log("--Signin.Component.apiSignin-- response: ", response)
      console.log("--Signin.Component.apiSignin-- fireToken: ", fireToken)
      if (response['code']) {
        if (response['code'] === 500) {
          createNotification('UPS!! Error de servidor', 'error')
        }
        if (response['code'] === 400) {
          createNotification('Error al crear el usuario', 'error')
        }
        if (response['code'] === 401) {
          createNotification('Ya existe un usuario con ese número de documento', 'warn')
        }
        if (response['code'] === 402) {
          createNotification('Ya existe un usuario con ese email', 'warn')
        }
        if (response['code'] === 200) {
          createNotification('Usuario creado con éxito!!!', 'success')
          dispatch(login({ user: response['data'], token: response['data']['_id'] }));
          history.push('/welcome');
          
        }
      } else {
        createNotification('Error al conectar con el servidor', 'error')
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
    aria-labelledby="contained-modal-title-vcenter"
    show={visibleSignin}
    centered
    onHide={() => closeModal()}
  >
    <Modal.Header closeButton>
      <Modal.Title style={{fontWeight: 'bold'}} className="ms-auto">
        Registrarse
      </Modal.Title>
    </Modal.Header>
    <hr/>
    <Modal.Body >
      <form className="Form" onSubmit={handleCreate} ref={formRef}>
        <div className="Form-div-1">
      <InputIcon Icon={AiOutlineUser} required = {true} name="name" placeholder= "Nombre"/>
      <InputIcon Icon={AiOutlineUser} required = {true} name="lastname" placeholder= "Apellido"/>
        </div>
        <InputIcon required = {true} Icon={AiOutlineMail} type= "email"name="email" placeholder= "Email"/>
        <div className="Form-div-2">
        <SelectModal required = {true} name="tipodocumento" options={tipoDocumento}/>
        <InputIcon required = {true} name="documento" Icon={FiUserCheck} placeholder= "Documento Identidad" />
        <SelectModal required = {true} name="city" options={[{name: 'Municipio'},...cities.data]}/>
        <InputIcon name ="celular" Icon={FiPhone} required = {true} placeholder= "Movil" />
        </div>
        <div className="Form-div-1">
    <InputIcon name="password" customIcon="passwordIcon" type="password" required = {true} Icon={FaCertificate} placeholder= "Contraseña" />
    <InputIcon name="password2" customIcon="passwordIcon" type="password" required = {true} Icon={FaCertificate} placeholder= "Confirmar Contraseña" />
        </div>
    <div >
    <input
                  type="checkbox"
                  className="Form-input--checkbox"
                  name='terminos' 
                 /> Al crear tu cuenta, estas aceptando los 
                <a href="/#" style={{ fontFamily: " Montserrat", color: "#858585" ,textDecoration: 'underline'}}> Términos y Condiciones</a> de TodoAk.<br></br>
    </div>
    <Button name="Crear Cuenta"/>

    {alertState &&
                <div className="alert alert-danger mt-3" role="alert">
                  {alertMessage}
                </div>
              }
              <p style = {{textAlign: 'center'}}>
          ¿Ya estas registrado en TodoAk ? <a
            onClick={() => clickOnLogin()}
            style= {{color:'#2994CD'}}
            href="/#">Ingresa
          </a>
  </p>
      </form>
    </Modal.Body>
    
  </Modal>



    // <Modal visible={visibleSignin} onClickBackdrop={closeModal}>
    //   {showLoading &&
    //     <LoaderSpinner show={showLoading} />
    //   }
    //   <div className="modal-header text-center">
    //     <h1 className="modal-title w-100" style={{ fontFamily: "Montserrat" }}>Regístrate</h1>
    //     <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} >
    //       <span aria-hidden="true">&times;</span>
    //     </button>
    //   </div>
    //   <div className="modal-body">
    //     <div >
    //       <div >
    //         <form onSubmit={handleCreate} ref={formRef}>
    //           <div className="form-group">
    //             <label htmlFor='email' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Correo Electrónico *</label>
    //             <input
    //               className="form-control"
    //               name='email'
    //               type='email'
    //               id='user-emailInput'
    //               required
    //               placeholder='Correo Electrónico' />
    //             <label htmlFor='password' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Contraseña *</label>
    //             <input
    //               className="form-control"
    //               name='password'
    //               type='password'
    //               id='user-passwordInput'
    //               required
    //               placeholder='Contraseña' />

    //             <label htmlFor='password2' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Repita Contraseña *</label>
    //             <input
    //               className="form-control"
    //               name='password2'
    //               type='password'
    //               id='user-password2Input'
    //               required
    //               placeholder='Repita Contraseña' />
    //             <label htmlFor='name' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Nombres *</label>
    //             <input
    //               className="form-control"
    //               name='name'
    //               type='text'
    //               id='user-nameInput'
    //               required
    //               placeholder='Nombres' />

    //             <label htmlFor='lastname' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Apellidos *</label>
    //             <input
    //               className="form-control"
    //               name='lastname'
    //               type='text'
    //               id='user-lastnameInput'
    //               required
    //               placeholder='Apellidos' />

    //             <label htmlFor='tipodocumento' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Tipo Documento *</label>
    //             <select id="user-tipodocumentoInput" name='tipodocumento'>
    //               <option value="CC">Cédula Ciudadanía</option>
    //               <option value="CE">Cédula Extranjería</option>
    //             </select>

    //             <label htmlFor='documento' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Documento *</label>
    //             <input
    //               className="form-control"
    //               name='documento'
    //               type='number'
    //               id='user-documentoInput'
    //               required
    //               placeholder='Documento Identidad' />

    //             <label htmlFor='celular' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Celular *</label>
    //             <input
    //               className="form-control"
    //               name='celular'
    //               type='number'
    //               id='user-celularInput'
    //               required
    //               placeholder='Número de Celular' />

    //             <br></br><br></br>
    //             <a href="#" style={{ fontFamily: " Montserrat", color: "#858585" }}>Términos y condiciones</a><br></br>
    //             <input
    //               style={{ fontFamily: " Montserrat", color: "#858585" }}
    //               type="checkbox"
    //               id="cbox1"
    //               name='terminos' /> Acepto

    //           </div>

    //           {alertState &&
    //             <div className="alert alert-danger mt-3" role="alert">
    //               {alertMessage}
    //             </div>
    //           }

    //           <div className="form-row text-center mb-3 mt-5">
    //             <div className="col-12">
    //               <button type="submit" disabled={showLoading} className="btn btn-primary" style={{ fontFamily: " Montserrat" }}>Regístrate</button>
    //             </div>
    //           </div>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </Modal>

  )
}

export default Connect(Signin)